import { FC, memo } from 'react';

import { CompanyDeviceRequestPureType, DeviceTypes } from 'domain/api/graphql/generated';

import { TEXTS } from '../../texts';

import styles from './index.module.scss';

interface ModalDescriptionProps {
  addressHasStream: boolean;
  isAddressEnabled?: boolean;
  isBindStreamFlow: boolean;
  deviceRequestsByPoint: CompanyDeviceRequestPureType[];
}

const ModalDescription: FC<ModalDescriptionProps> = ({
  addressHasStream,
  isAddressEnabled,
  isBindStreamFlow,
  deviceRequestsByPoint,
}) => {
  if (!addressHasStream) {
    return <div className={styles.description}>{TEXTS.MODAL_BIND_SUCCESS_NO_STREAM_DESC}</div>;
  }

  if (isBindStreamFlow && deviceRequestsByPoint.length !== 0) {
    const hasAndroidBox = deviceRequestsByPoint.some((request) => request.deviceType === DeviceTypes.Androidbox);
    const hasSberBoom = deviceRequestsByPoint.some((request) => request.deviceType === DeviceTypes.BoomSpeaker);

    if (hasAndroidBox && hasSberBoom) {
      return (
        <div className={styles.description}>
          {TEXTS.MODAL_BIND_SUCCESS_DESC_SBER_DEVICE_AND_BOOM_REQUESTED(isAddressEnabled)}
        </div>
      );
    }

    return (
      <div className={styles.description}>
        {hasAndroidBox
          ? TEXTS.MODAL_BIND_SUCCESS_DESC_SBER_DEVICE_REQUESTED(isAddressEnabled)
          : TEXTS.MODAL_BIND_SUCCESS_DESC_SBER_BOOM_REQUESTED(isAddressEnabled)}
      </div>
    );
  }

  const successBindDeviceDescription = isAddressEnabled
    ? TEXTS.MODAL_BIND_SUCCESS_DESC
    : TEXTS.MODAL_BIND_SUCCESS_ADDRESS_NO_ACTIVE_DESC;

  return <div className={styles.description}>{successBindDeviceDescription}</div>;
};

export default memo(ModalDescription);
